export const PDF_TOPICS = {
  user: (userId: any) => `users/${userId}`,
  GENERATION: {
    SUCCESS: "pdf.generation.success",
    FAILED: "pdf.generation.failed",
  },
  EMAIL_DELIVERY: {
    SUCCESS: "pdf.email-delivery.success",
    FAILED_PARTIALLY: "pdf.email-delivery.failed.partially",
    FAILED: "pdf.email-delivery.failed",
  },
};

export const STORAGE_KEYS = {
  PDF_GENERATION: "last_pdf_generation_event_id",
  EMAIL_DELIVERY: "last_pdf_email_delivery_event_id",
};
